import axios from "axios";

const baseURL = "https://ufoodapi.herokuapp.com/unsecure";

export default axios.create({
  baseURL
});
